import { Button } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const ButtonsContainerStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  margin-bottom: 7rem;
`;

export const ButtonStyled = styled(Button)`
  width: 25rem;
  padding: 0.1rem 1rem;
`;
